import { DateFilter } from '../../types/date-filter';
import { generateDate } from '../../utils/dummy-data';
import { Role } from '../model/enum/role';
import { Status } from '../model/enum/status';
import { User } from '../model/user';

export const USERS: User[] = [
  {
    id: 1,
    firstName: 'Tatiania',
    lastName: 'de Copeman',
    username: 'tdecopeman0',
    password: 'jG6,r|J05L@s',
    email: 'tdecopeman0@sina.com.cn',
    mobile: {},
    role: Role.CASHIER,
    status: Status.PENDING,
    jobTitle: 'Senior Developer',
    token: 'c889d9f7-b36f-41ba-8c36-b7d5e7c16f0f',
    createdAt: generateDate(DateFilter.TODAY),
    updatedAt: new Date('2024-05-02T14:30:00Z'),
  },
  {
    id: 2,
    firstName: 'Hogan',
    lastName: 'Winckle',
    username: 'hwinckle1',
    password: 'gP8,9(Sb',
    email: 'hwinckle1@mapy.cz',
    mobile: {
      countryCode: '+63',
      number: '+631234567891',
    },
    role: Role.MANAGER,
    status: Status.INACTIVE,
    jobTitle: 'Teacher',
    token: '4c7f67e4-fa3b-4bae-93f5-7d911016caac',
    createdAt: generateDate(DateFilter.TODAY),
    updatedAt: new Date('2024-05-01T12:15:00Z'),
  },
  {
    id: 3,
    firstName: 'Dillie',
    lastName: 'Tellesson',
    username: 'dtellesson2',
    password: 'eW3$AH}vhoH0ww',
    email: 'dtellesson2@desdev.cn',
    mobile: {
      countryCode: '+63',
      number: '+631234567891',
    },
    role: Role.ADMIN,
    status: Status.ACTIVE,
    jobTitle: 'Actuary',
    token: '023173ab-ef8b-458c-a6b8-7df577e48e21',
    createdAt: generateDate(DateFilter.LAST_7_DAYS),
    updatedAt: new Date('2024-04-30T09:45:00Z'),
  },
  {
    id: 4,
    firstName: 'Dewie',
    lastName: 'Bigg',
    username: 'dbigg3',
    password: 'nV9@+I7N"BLN',
    email: 'dbigg3@vkontakte.ru',
    mobile: {
      countryCode: '+63',
      number: '+631234567891',
    },
    role: Role.CASHIER,
    status: Status.INACTIVE,
    jobTitle: 'General Manager',
    token: 'a3506029-a827-4379-824c-666bf239567a',
    createdAt: generateDate(DateFilter.LAST_7_DAYS),
    updatedAt: new Date('2024-04-29T17:00:00Z'),
  },
  {
    id: 5,
    firstName: 'Scott',
    lastName: 'Uccello',
    username: 'succello4',
    password: 'aE7+ItIW?4"&T',
    email: 'succello4@nytimes.com',
    mobile: {
      countryCode: '+63',
      number: '+631234567891',
    },
    role: Role.ADMIN,
    status: Status.INACTIVE,
    jobTitle: 'Software Test Engineer IV',
    token: '5d3d5e7d-225c-4a56-a533-e1d6d2de7fa5',
    createdAt: generateDate(DateFilter.LAST_4_WEEKS),
    updatedAt: new Date('2024-04-28T11:00:00Z'),
  },
  {
    id: 6,
    firstName: 'Hermina',
    lastName: 'Stucke',
    username: 'hstucke5',
    password: 'rK8,ga8BaFGwcP7<',
    email: 'hstucke5@rakuten.co.jp',
    mobile: {
      countryCode: '+63',
      number: '+631234567891',
    },
    role: Role.ADMIN,
    status: Status.ACTIVE,
    jobTitle: 'Design Engineer',
    token: '9ab9a33f-4731-44f6-920f-e493ef32c97a',
    createdAt: generateDate(DateFilter.LAST_4_WEEKS),
    updatedAt: new Date('2024-04-27T22:30:00Z'),
  },
  {
    id: 7,
    firstName: 'Felice',
    lastName: 'Cottham',
    username: 'fcottham6',
    password: 'gZ7@_v?,2XDt',
    email: 'fcottham6@nationalgeographic.com',
    mobile: {
      countryCode: '+63',
      number: '+631234567891',
    },
    role: Role.CASHIER,
    status: Status.INACTIVE,
    jobTitle: 'Assistant Professor',
    token: '9d65fb3a-13d9-45e6-a3ac-297b1c992d18',
    createdAt: generateDate(DateFilter.LAST_12_MONTHS),
    updatedAt: new Date('2024-04-26T19:15:00Z'),
  },
  {
    id: 8,
    firstName: 'Kevin',
    lastName: 'Mitton',
    username: 'kmitton7',
    password: 'iR3=h_tvOn2YacRK',
    email: 'kmitton7@elpais.com',
    mobile: {
      countryCode: '+63',
      number: '+631234567891',
    },
    role: Role.CASHIER,
    status: Status.ACTIVE,
    jobTitle: 'Paralegal',
    token: '6886d8b2-7925-4356-bbed-7b164da87969',
    createdAt: generateDate(DateFilter.LAST_12_MONTHS),
    updatedAt: new Date('2024-04-25T07:00:00Z'),
  },
  {
    id: 9,
    firstName: 'Rosanne',
    lastName: 'Isakov',
    username: 'risakov8',
    password: 'fX1*A5OjSL3mL',
    email: 'risakov8@pbs.org',
    mobile: {
      countryCode: '+63',
      number: '+631234567891',
    },
    role: Role.MANAGER,
    status: Status.ACTIVE,
    jobTitle: 'Structural Engineer',
    token: '3fa94d47-8ab3-4ab7-a011-fddbcb487d7e',
    createdAt: generateDate(DateFilter.MAX),
    updatedAt: new Date('2024-04-24T15:45:00Z'),
  },
  {
    id: 10,
    firstName: 'Laurent',
    lastName: 'Holcroft',
    username: 'lholcroft9',
    password: "fU6'oOw%ZQWWx",
    email: 'lholcroft9@tamu.edu',
    mobile: {
      countryCode: '+63',
      number: '+631234567891',
    },
    role: Role.ADMIN,
    status: Status.ACTIVE,
    jobTitle: 'Electrical Engineer',
    token: 'b0d9b6bc-eb38-4e8d-968a-9a8c39a38793',
    createdAt: generateDate(DateFilter.MAX),
    updatedAt: new Date('2024-04-23T23:30:00Z'),
  },
].map((item) => User.fromJSON({ ...item, isOnboardingCompleted: true, mobile: { countryCode: '', number: '' } }));